import React, { Component } from "react";
import styled, { css } from "styled-components";

const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 2rem 2rem 0;
  bottom: 0;

  @media (max-width: 1030px) {
    padding: 1rem;
  }

  ${props =>
    props.poppins &&
    css`
      font-family: "Poppins", sans-serif;
    `}
`;

const Legal = styled.p`
  font-size 0.8rem;

  ${props =>
    props.poppins &&
    css`
      font-family: "Poppins", sans-serif;
    `}
`;

class Footer extends Component {
  render() {
    return (
      <FooterContainer>
        <Legal>
          Just a quick message from{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://twitter.com/jackdavidevans"
          >
            @jackdavidevans
          </a>{" "}
          warning you of our seemingly impending doom.
        </Legal>

        {/* <Legal>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/privacy-policy.html"
          >
            Privacy
          </a>
        </Legal> */}
      </FooterContainer>
    );
  }
}

export default Footer;
